import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";

import SectionWrapper from '../UI/SectionWrapper';
import muthoot from "../../../Assets/Clients/muthoot.png";
import atl from "../../../Assets/Clients/atl.png";
import treat from "../../../Assets/Clients/treat.png";
import al_ansari from "../../../Assets/Clients/al_ansari.png";
import purpleCore from "../../../Assets/Clients/purpleCore.png";

import { COLORS } from "../../../Constants/colors";

const clients = [muthoot, atl, treat, al_ansari, purpleCore];

// ─── Styled Components ─────────────────────────────

const ClientSectionWrapper = styled.section`
  width: 100%;
  background: ${COLORS.cardBackground};
  border-radius: 12px;
`;

const Container = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 80px 30px;

  @media (max-width: 768px) {
    padding: 48px 16px;
  }
`;

const Heading = styled.h2`
  text-align: center;
  font-size: 2rem;
  color: ${COLORS.primary};
  margin-bottom: 48px;
`;

const LogoGrid = styled.div`
    margin-top: 50px;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 40px;
    align-items: center;
    justify-items: center;
`;

const LogoBox = styled(motion.div)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100px;
  padding: 20px;
  background: ${COLORS.backgroundLight};
  border-radius: 10px;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 4px 12px ${COLORS.shadowColor};
  }
`;

const LogoImage = styled(motion.img)`
  max-width: 100%;
  max-height: 60px;
  object-fit: contain;
  transition: transform 0.3s ease;
`;

// ─── Component ─────────────────────────────────────

const ClientLogos = () => {
  return (
    <SectionWrapper heading="CLIENTS">
        <LogoGrid>
          {clients.map((logo, index) => {
            const isLarge = index === 0 || index === 1 || index=== 4;
            return(
              <LogoImage 
                  src={logo} 
                  alt={`Client ${index + 1}`} 
                  style={{
                      maxHeight: isLarge ? "90px" : "60px", 
                  }}
                  whileHover={{ scale: isLarge ? 1.5 : 1.25 }}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.15, duration: 0.1 }}
              />
          )})}
        </LogoGrid>
    </SectionWrapper>
  );
};

export default ClientLogos;

